/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-call */
import { ubtSendError } from '@/shared/utils/ubt';
import { getWisdomConfig } from '@/shared/wisdom';

export const FINANCE_WX_MINI_PROGRAM = {
  systemCode: 'Zyq04',
  bizCode: 'Zyq04',
  appId: 'wx40ddbc37ec3a370c',
};

/** 微信官方js sdk链接，webview嵌入当前项目时加载 */
export const WX_JS_SDK_URL = 'https://res.wx.qq.com/open/js/jweixin-1.6.0.js';

/** webview可以访问的域名列表缓存 */
let currentEnvAccessWebDomainListCache: string[] | null = null;

/**
 * webview现支持访问的域名
 * 维护wisdom配置中心：https://config.hellobike.cn/#/project/detail?projectName=AppFinanceH5Web&projectGuid=8fa0876b0e60472b9cbf257a9bc63ad4
 */
export const getWebviewAccessDomain = async (appId: string): Promise<string[]> => {
  try {
    if (!currentEnvAccessWebDomainListCache) {
      const config = await getWisdomConfig<Record<string, { domainList: string[]; }>>('mpWebviewAccessDomain');
      const domainList = config[appId]?.domainList || [];

      if (!domainList.length) {
        throw new Error(`FinanceMP WebviewAccessDomain not found appId: ${appId}`);
      }

      // eslint-disable-next-line no-console
      console.log('current webview access domainList:', domainList);

      currentEnvAccessWebDomainListCache = domainList;
    }

    return currentEnvAccessWebDomainListCache;
  } catch (err) {
    ubtSendError(err as Error);

    /** 若是服务异常，则返回默认域名列表(哈啰、臻有钱小程序 合集域名) */
    return Promise.resolve([
      'https://hello-finance.cn-hangzhou.oss.aliyuncs.com',
      'https://hello-finance.oss-cn-hangzhou.aliyuncs.com',
      'https://m2.hellobike.com',
      'https://m.hellobike.com',
      'https://miniprogram-kyc.tencentcloudapi.com',
      'https://opengateway-contract.zhaojiling.com',
    ]);
  }
};

/** 小程序 & h5消息交互行为 */
export enum NotifyCommandEnum {
  /** 账号登出 */
  LOGOUT = 'logout',
}
